import React from 'react';
import { cardTypes, brand } from '../../agentTheme';

/**
 * Renders a rich progress card for image generation tool calls.
 * Shows prompt preview, animated progress bar, and status.
 */
export default function GenerationStatusCard({ toolInput, isDone, isFailed, failMessage }) {
  const prompt = toolInput?.positive_prompt || toolInput?.prompt || toolInput?.description || '';
  const promptPreview = prompt.length > 120 ? prompt.slice(0, 120) + '...' : prompt;
  const variations = toolInput?.variations || 1;
  const resolution = toolInput?.resolution || '2K';

  if (isFailed) {
    return (
      <div className="smart-card" style={{ background: 'rgba(248,113,113,0.05)', border: '1px solid rgba(248,113,113,0.15)' }}>
        <div className="smart-card-header" style={{ color: '#f87171' }}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="10" /><line x1="15" y1="9" x2="9" y2="15" /><line x1="9" y1="9" x2="15" y2="15" />
          </svg>
          Generation failed
        </div>
        {failMessage && (
          <div style={{ fontSize: 12, color: 'rgba(248,113,113,0.6)', marginTop: 6, lineHeight: 1.5 }}>
            {failMessage}
          </div>
        )}
      </div>
    );
  }

  if (isDone) return null; // completed generation cards show image results via ToolCallCard

  return (
    <div className="smart-card" style={{ background: cardTypes.generation.bg, border: `1px solid ${cardTypes.generation.border}` }}>
      <div className="smart-card-header" style={{ color: cardTypes.generation.accent }}>
        <div style={{
          width: 18, height: 18, borderRadius: '50%',
          border: `2px solid ${brand.coral}`, borderTopColor: 'transparent',
          animation: 'spin 0.8s linear infinite',
        }} />
        Generating {variations > 1 ? `${variations} variations` : 'image'}...
      </div>

      {promptPreview && (
        <div style={{
          fontSize: 12, color: 'rgba(255,255,255,0.3)', fontStyle: 'italic',
          marginTop: 6, lineHeight: 1.5,
          overflow: 'hidden', textOverflow: 'ellipsis',
          display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical',
        }}>
          {promptPreview}
        </div>
      )}

      {/* Animated progress bar */}
      <div style={{
        height: 3, borderRadius: 2, marginTop: 10,
        background: 'rgba(255,255,255,0.06)', overflow: 'hidden',
      }}>
        <div style={{
          height: '100%', borderRadius: 2,
          background: brand.gradient,
          animation: 'progressFill 25s ease-out forwards',
        }} />
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 6 }}>
        <span style={{ fontSize: 10, color: 'rgba(255,255,255,0.2)' }}>{resolution}</span>
        <span style={{ fontSize: 10, color: 'rgba(255,255,255,0.15)' }}>~15-45s</span>
      </div>
    </div>
  );
}
